//dibya vai code ///

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import Modal from "./Modal";
// import { fetchMessageTypes } from "../../hooks/fetchMessageTypes ";
// import { fetchInitiatedByList } from "../../hooks/fetchInitiatedByList";
// import { ApiUrl } from "../../../ApiUrl";

// function SelectedStudentTable({}) {
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [messageTypes, setMessageTypes] = useState([]);
//   const [initiatedByList, setInitiatedByList] = useState([]);
//   const [selectedMessageType, setSelectedMessageType] = useState("");
//   const [fullStudentData, setFullStudentData] = useState([]);
//   const [studentData, setStudentData] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterState, setFilterState] = useState({
//     schoolAdmissionNo: "",
//     barcode: "",
//   });
//   const itemsPerPage = 10;
//   const [formState, setFormState] = useState({
//     messageType: "",
//     messageDate: "",
//     smsTo: "B",
//     initiatedBy: "",
//     initiationRemarks: "",
//     messageTime: "",
//     schoolAdmissionNo: "",
//     barcode: "",
//     message: "",
//   });
//   const [tableData, setTableData] = useState({
//     initiatedBy: "",
//     initiationRemarks: "",
//     message: "",
//   });
//   const [isChecked, setIsChecked] = useState(false);
//   const navigate = useNavigate();
//   const initiatedByRef = useRef(null);
//   useEffect(() => {
//     const fetchData = async () => {
//       const data = await fetchInitiatedByList();
//       setInitiatedByList(data);
//     };
//     fetchData();
//   }, []);

//   const handleOpenModal = () => setShowModal(true);
//   const handleClear = () => {
//     setFormState((prevState) => ({
//       messageType: "",
//       messageDate: new Date().toISOString().split("T")[0],
//       smsTo: prevState.smsTo,
//       initiatedBy: "",
//       initiationRemarks: "",
//       messageTime: "",
//       schoolAdmissionNo: "",
//       barcode: "",
//       message: "",
//     }));

//     setFilterState({ schoolAdmissionNo: "", barcode: "" });
//     setSelectedMessageType("");
//     setIsChecked(false);
//     setTableData({});
//     setSelectedStudents([]);
//   };
//   // Close the current page
//   const handleClose = () => navigate("/admin/student-message");
//   useEffect(() => {
//     const fetchData = async () => {
//       const data = await fetchInitiatedByList();
//       setInitiatedByList(data);
//     };
//     fetchData();
//   }, []);
//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormState((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };
//   // Set default message date on mount
//   useEffect(() => {
//     const today = new Date();
//     const formattedDate = today.toISOString().split("T")[0];
//     setFormState((prevState) => ({
//       ...prevState,
//       messageDate: formattedDate,
//     }));
//   }, []);
//   // Fetch message types
//   useEffect(() => {
//     const loadMessageTypes = async () => {
//       const types = await fetchMessageTypes();
//       setMessageTypes(types);
//     };

//     loadMessageTypes();
//   }, []);

//   // Fetch initiatedBy options
//   useEffect(() => {
//     const loadInitiatedByOptions = async () => {
//       const list = await fetchInitiatedByList();
//       setInitiatedByList(list);
//     };

//     loadInitiatedByOptions();
//   }, []);

//   useEffect(() => {
//     setIsDisabled(selectedMessageType === "");
//   }, [selectedMessageType]);

//   const handleSelectChange = (event) => {
//     setSelectedMessageType(event.target.value);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   const handleSelectStudents = (students) => {
//     setSelectedStudents(students);
//   };

//   const handleCheckboxChange = (e) => {
//     const checked = e.target.checked;
//     setIsChecked(checked);

//     if (checked) {
//       // Copy form data to table data for all students
//       const updatedTableData = {};
//       selectedStudents.forEach((student) => {
//         const studentId = student.studentBasicDetails.id;
//         updatedTableData[studentId] = {
//           initiatedBy: formState.initiatedBy,
//           initiationRemarks: formState.initiationRemarks,
//           message: formState.message,
//         };
//       });
//       setTableData(updatedTableData);
//     } else {
//       const clearedTableData = {};
//       selectedStudents.forEach((student) => {
//         const studentId = student.studentBasicDetails.id;
//         clearedTableData[studentId] = {
//           initiatedBy: "",
//           initiationRemarks: "",
//           message: "",
//         };
//       });
//       setTableData(clearedTableData);
//     }
//   };
//   const handleTableDataChange = (e, studentId) => {
//     const { name, value } = e.target;

//     setTableData((prevTableData) => ({
//       ...prevTableData,
//       [studentId]: {
//         ...prevTableData[studentId],
//         [name]: value,
//       },
//     }));
//   };

//   const handleSendMessage = async () => {
//     if (!selectedMessageType || isNaN(selectedMessageType)) {
//       alert("Please select a valid 'Message Type'.");
//       return;
//     }
//     for (let student of selectedStudents) {
//       const { studentBasicDetails: details } = student;
//       const studentId = details.id;

//       const studentFormData = tableData[studentId] || {};

//       if (
//         !studentFormData.initiatedBy ||
//         studentFormData.initiatedBy.trim() === ""
//       ) {
//         alert(`Please select 'Initiated By' for student ${details.name}.`);
//         return;
//       }
//     }
//     for (let student of selectedStudents) {
//       const { studentBasicDetails: details } = student;
//       const studentId = details.id;

//       const studentFormData = tableData[studentId] || {};

//       if (!studentFormData.message || studentFormData.message.trim() === "") {
//         alert(`Please enter a 'Message' for student ${details.name}.`);
//         return;
//       }
//     }
//     if (!selectedStudents || selectedStudents.length === 0) {
//       alert("Please select at least one student.");
//       return;
//     }

//     if (!formState.messageTime || formState.messageTime.trim() === "") {
//       alert("Please select a valid 'Message Time'.");
//       return;
//     }
//     const smsToMapping = { Father: "F", Mother: "M", Both: "B" };
//     const smsToValue = smsToMapping[formState.smsTo] || "";
//     const messageData = selectedStudents.map((student) => {
//       const { studentBasicDetails: details } = student;
//       const studentId = details.id;
//       const studentFormData = tableData[studentId] || {};
//       return {
//         studentId,
//         initiatedBy: studentFormData.initiatedBy || formState.initiatedBy || "",
//         initiationRemarks:
//           studentFormData.initiationRemarks ||
//           formState.initiationRemarks ||
//           "",
//         message: studentFormData.message || formState.message || "",
//       };
//     });
//     // Prepare the payload
//     const payload = {
//       loginId: sessionStorage.getItem("userId"),
//       message_type: selectedMessageType,
//       message_date: formState.messageDate,
//       message_time: formState.messageTime,
//       sendmessage: formState.smsTo || "",
//       academicyearId: localStorage.getItem("academicSessionId"),
//       studentId: messageData.map((item) => item.studentId),
//       message: messageData.map((item) => item.message),
//       initiatedBy: messageData.map((item) => item.initiatedBy),
//       initiated_remarks: messageData.map((item) => item.initiationRemarks),
//     };

//     try {
//       // Send the payload
//       const response = await fetch(
//         `${ApiUrl.apiurl}MessageSEND/StudentMessageCreate/`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );
//       const data = await response.json();
//       if (data.message && data.message === "message send sucessfully!!") {
//         alert(data.message);
//         handleClear();
//       } else {
//         alert("Failed to send messages. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       alert("An error occurred while sending messages.");
//     }
//   };

//   useEffect(() => {
//     const fetchFullStudentData = async () => {
//       try {
//         const academicSessionId = localStorage.getItem("academicSessionId");
//         if (!academicSessionId) {
//           console.error("No academic session ID found in local storage");
//           return;
//         }
//         const response = await fetch(
//           `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
//         );
//         if (!response.ok) {
//           throw new Error("Error fetching student data");
//         }
//         const data = await response.json();
//         if (data.data) {
//           setFullStudentData(data.data);
//         } else {
//           console.warn("No data found for the given academic session ID");
//         }
//       } catch (error) {
//         console.error("Fetch error:", error);
//       }
//     };
//     fetchFullStudentData();
//   }, []);

//   const handleAddStudents = () => {
//     const filteredStudents = fullStudentData.filter((student) => {
//       const { studentBasicDetails: details } = student;
//       const schoolAdmissionNo = String(details.school_admission_no || "");
//       const barcode = String(details.barcode || "");
//       const admissionNoMatch = schoolAdmissionNo.includes(
//         filterState.schoolAdmissionNo
//       );
//       const barcodeMatch = barcode.includes(filterState.barcode);
//       return admissionNoMatch && barcodeMatch;
//     });
//     setSelectedStudents(filteredStudents);
//   };
//   const handleRemoveRow = (studentId) => {
//     // Remove the student from the selectedStudents
//     const updatedStudents = selectedStudents.filter(
//       (student) => student.studentBasicDetails.id !== studentId
//     );
//     setSelectedStudents(updatedStudents);
//     const updatedTableData = { ...tableData };
//     delete updatedTableData[studentId];
//     setTableData(updatedTableData);
//   };
//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 STUDENT MESSAGE
//               </p>

//               <div className="row mb-3 mt-3 mx-0">
//                 <div className="col-12">
//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       width: "150px",
//                     }}
//                     onClick={handleSendMessage}
//                   >
//                     Send Message
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-secondary me-2"
//                     style={{
//                       width: "150px",
//                     }}
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-danger me-2"
//                     style={{
//                       width: "150px",
//                     }}
//                     onClick={handleClose}
//                   >
//                     Close
//                   </button>
//                 </div>
//               </div>

//               <div className="row mt-3 mx-2">
//                 <div className="col-12 custom-section-box">
//                   <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
//                     <div className="row flex-grow-1  mt-2">
//                       <div className="col-12 col-md-3 mb-4">
//                         <label htmlFor="message-type" className="form-label">
//                           Message Type
//                         </label>
//                         <select
//                           id="message-type"
//                           className="detail"
//                           value={selectedMessageType}
//                           onChange={handleSelectChange}
//                         >
//                           <option value="">Select message type</option>
//                           {messageTypes.map((type) => (
//                             <option key={type.id} value={type.id}>
//                               {type.messageType_desc}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       <div className="col-12 col-md-3 mt-4 ">
//                         <button
//                           type="button"
//                           className="btn btn-primary btn-sm mb-3"
//                           disabled={isDisabled}
//                           onClick={handleOpenModal}
//                         >
//                           Add Student(s)
//                         </button>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <div className="mb-3">
//                           <label htmlFor="messageDate" className="form-label">
//                             Message Date
//                           </label>
//                           <input
//                             type="date"
//                             className="form-control detail"
//                             id="messageDate"
//                             name="messageDate"
//                             value={formState.messageDate}
//                             onChange={handleChange}
//                           />
//                         </div>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <div className="mb-3">
//                           <label className="form-label">Send SMS to</label>
//                           <div className="d-flex">
//                             <div className="form-check me-2">
//                               <input
//                                 className="form-check-input"
//                                 type="radio"
//                                 name="smsTo"
//                                 id="smsToFather"
//                                 value="F"
//                                 checked={formState.smsTo === "F"}
//                                 onChange={handleChange}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor="smsToFather"
//                               >
//                                 Father
//                               </label>
//                             </div>
//                             <div className="form-check me-2">
//                               <input
//                                 className="form-check-input"
//                                 type="radio"
//                                 name="smsTo"
//                                 id="smsToMother"
//                                 value="M"
//                                 checked={formState.smsTo === "M"}
//                                 onChange={handleChange}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor="smsToMother"
//                               >
//                                 Mother
//                               </label>
//                             </div>
//                             <div className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="radio"
//                                 name="smsTo"
//                                 id="smsToBoth"
//                                 value="B"
//                                 checked={formState.smsTo === "B"}
//                                 onChange={handleChange}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor="smsToBoth"
//                               >
//                                 Both
//                               </label>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <div className="mb-3">
//                           <label htmlFor="messageTime" className="form-label">
//                             Message Time
//                           </label>
//                           <input
//                             type="time"
//                             className="form-control detail"
//                             id="messageTime"
//                             name="messageTime"
//                             value={formState.messageTime}
//                             onChange={handleChange}
//                           />
//                         </div>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <div className="mb-3">
//                           <label
//                             htmlFor="schoolAdmissionNo"
//                             className="form-label"
//                           >
//                             School Admission No
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control detail"
//                             id="schoolAdmissionNo"
//                             name="schoolAdmissionNo"
//                             value={filterState.schoolAdmissionNo}
//                             onChange={(e) =>
//                               setFilterState({
//                                 ...filterState,
//                                 schoolAdmissionNo: e.target.value,
//                               })
//                             }
//                           />
//                         </div>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <div className="mb-3">
//                           <label htmlFor="barcode" className="form-label">
//                             Barcode
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control detail"
//                             id="barcode"
//                             name="barcode"
//                             value={filterState.barcode}
//                             onChange={(e) =>
//                               setFilterState({
//                                 ...filterState,
//                                 barcode: e.target.value,
//                               })
//                             }
//                           />
//                         </div>
//                       </div>

//                       <div className="col-12 col-md-3 mt-4">
//                         <button
//                           type="button"
//                           className="btn btn-primary btn-sm mb-3"
//                           onClick={handleAddStudents}
//                         >
//                           Add Students
//                         </button>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <label htmlFor="from-class" className="form-label">
//                           Initiated By
//                         </label>
//                         <select
//                           id="from-class"
//                           className="detail"
//                           ref={initiatedByRef}
//                           name="initiatedBy"
//                           value={formState.initiatedBy}
//                           onChange={handleChange}
//                         >
//                           <option value="">Select initiated by</option>
//                           {initiatedByList.map((item) => (
//                             <option key={item.id} value={item.id}>
//                               {item.InitiatedBy_desc}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <div className="mb-3">
//                           <label
//                             htmlFor="initiationRemarks"
//                             className="form-label"
//                           >
//                             Initiation Remarks
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control detail"
//                             id="initiationRemarks"
//                             name="initiationRemarks"
//                             value={formState.initiationRemarks}
//                             onChange={handleChange}
//                           />
//                         </div>
//                       </div>

//                       <div className="col-12 col-md-3 mb-4">
//                         <label htmlFor="message" className="form-label">
//                           Message
//                         </label>
//                         <textarea
//                           className="form-control detail"
//                           id="message"
//                           rows="3"
//                           name="message"
//                           value={formState.message}
//                           onChange={handleChange}
//                           style={{ resize: "both", overflow: "auto" }}
//                         ></textarea>
//                         <div className="form-check mt-2">
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             id="copyMessageDetails"
//                             checked={isChecked}
//                             onChange={handleCheckboxChange}
//                           />
//                           <label
//                             className="form-check-label"
//                             htmlFor="copyMessageDetails"
//                           >
//                             Copy Message Details
//                           </label>
//                         </div>
//                       </div>

//                       <Modal
//                         show={showModal}
//                         handleClose={handleCloseModal}
//                         onSelectStudent={handleSelectStudents}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="col-12">
//                 <div className="table-responsive">
//                   <table className="table table-bordered ">
//                     <thead>
//                       <tr>
//                         <th>Sr.No</th>
//                         <th>Class</th>
//                         <th>Section</th>
//                         <th>Roll No</th>
//                         <th
//                           style={{ paddingLeft: "50px", paddingRight: "50px" }}
//                         >
//                           Student Name
//                         </th>
//                         <th>School Admission No</th>
//                         <th>Barcode</th>
//                         <th
//                           style={{ paddingLeft: "50px", paddingRight: "50px" }}
//                         >
//                           Father Name
//                         </th>
//                         <th
//                           style={{ paddingLeft: "50px", paddingRight: "50px" }}
//                         >
//                           Mother Name
//                         </th>
//                         <th
//                           style={{ paddingLeft: "40px", paddingRight: "40px" }}
//                         >
//                           Initiated By
//                         </th>
//                         <th
//                           style={{ paddingLeft: "40px", paddingRight: "40px" }}
//                         >
//                           Initiation Remarks
//                         </th>
//                         <th
//                           style={{ paddingLeft: "60px", paddingRight: "60px" }}
//                         >
//                           Message
//                         </th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {selectedStudents.length > 0 ? (
//                         selectedStudents.map((student, index) => {
//                           const { studentBasicDetails: details } = student;
//                           const studentId = details.id;
//                           const studentData = tableData[studentId] || {};

//                           return (
//                             <tr key={studentId}>
//                               <td>{index + 1}</td>
//                               <td>{details.classname}</td>
//                               <td>{details.sectionname}</td>
//                               <td>{details.rollno}</td>
//                               <td>{`${details.first_name} ${
//                                 details.middle_name || ""
//                               } ${details.last_name}`}</td>
//                               <td>{details.school_admission_no}</td>
//                               <td>{details.barcode}</td>
//                               <td>{details.father_name}</td>
//                               <td>{details.mother_name}</td>
//                               <td>
//                                 <select
//                                   className="form-select"
//                                   value={
//                                     tableData[studentId]?.initiatedBy || ""
//                                   }
//                                   name="initiatedBy"
//                                   onChange={(e) =>
//                                     handleTableDataChange(e, studentId)
//                                   }
//                                 >
//                                   <option value="">Select initiated by</option>
//                                   {initiatedByList.map((item) => (
//                                     <option key={item.id} value={item.id}>
//                                       {item.InitiatedBy_desc}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </td>
//                               <td>
//                                 <input
//                                   type="text"
//                                   className="form-control detail"
//                                   name="initiationRemarks"
//                                   value={
//                                     tableData[studentId]?.initiationRemarks ||
//                                     ""
//                                   }
//                                   onChange={(e) =>
//                                     handleTableDataChange(e, studentId)
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 <textarea
//                                   className="form-control detail"
//                                   rows="2"
//                                   name="message"
//                                   value={tableData[studentId]?.message || ""}
//                                   onChange={(e) =>
//                                     handleTableDataChange(e, studentId)
//                                   }
//                                   style={{ resize: "both", overflow: "auto" }}
//                                 ></textarea>
//                               </td>
//                               <td>
//                                 <button
//                                   type="button"
//                                   className="btn btn-danger"
//                                   onClick={() => handleRemoveRow(studentId)}
//                                 >
//                                   Remove
//                                 </button>
//                               </td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td colSpan="12" className="text-center">
//                             No record found.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SelectedStudentTable;

///priyabrat code //

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import { fetchMessageTypes } from "../../hooks/fetchMessageTypes ";
import { fetchInitiatedByList } from "../../hooks/fetchInitiatedByList";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";

function SelectedStudentTable({ }) {
  const [isDisabled, setIsDisabled] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [messageTypes, setMessageTypes] = useState([]);
  const [initiatedByList, setInitiatedByList] = useState([]);
  const [selectedMessageType, setSelectedMessageType] = useState("");
  const [fullStudentData, setFullStudentData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterState, setFilterState] = useState({
    barcode: "",
  });
  const itemsPerPage = 10;
  const [formState, setFormState] = useState({
    messageType: "",
    messageDate: "",
    smsTo: "B",
    initiatedBy: "",
    initiationRemarks: "",
    messageTime: "",
    barcode: "",
    message: "",
  });
  const [tableData, setTableData] = useState({
    initiatedBy: "",
    initiationRemarks: "",
    message: "",
  });
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  const initiatedByRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchInitiatedByList();
      setInitiatedByList(data);
    };
    fetchData();
  }, []);

  const initiatedByOptions = initiatedByList.map((item) => ({
    value: item.id,
    label: item.InitiatedBy_desc,
  }));

  // Custom handler for React Select
  const handleInitiatedByChange = (selectedOption) => {
    const selectedValue = selectedOption?.value || "";
    setFormState((prevState) => ({
      ...prevState,
      initiatedBy: selectedValue,
    }));
  };
  const handleOpenModal = () => setShowModal(true);
  const handleClear = () => {
    setFormState((prevState) => ({
      messageType: "",
      messageDate: new Date().toISOString().split("T")[0],
      smsTo: prevState.smsTo,
      initiatedBy: "",
      initiationRemarks: "",
      messageTime: "",
      barcode: "",
      message: "",
    }));

    setFilterState({ barcode: "" });
    setSelectedMessageType("");
    setIsChecked(false);
    setTableData({});
    setSelectedStudents([]);
  };
  // Close the current page
  const handleClose = () => navigate("/admin/student-message");
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchInitiatedByList();
      setInitiatedByList(data);
    };
    fetchData();
  }, []);
  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  // Set default message date on mount
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setFormState((prevState) => ({
      ...prevState,
      messageDate: formattedDate,
    }));
  }, []);
  // Fetch message types
  useEffect(() => {
    const loadMessageTypes = async () => {
      const types = await fetchMessageTypes();
      setMessageTypes(types);
    };

    loadMessageTypes();
  }, []);

  // Fetch initiatedBy options
  useEffect(() => {
    const loadInitiatedByOptions = async () => {
      const list = await fetchInitiatedByList();
      setInitiatedByList(list);
    };

    loadInitiatedByOptions();
  }, []);

  useEffect(() => {
    setIsDisabled(selectedMessageType === "");
  }, [selectedMessageType]);

  const messageTypeOptions = messageTypes.map((type) => ({
    value: type.id,
    label: type.messageType_desc,
  }));

  // Handle selection
  const handleSelectChange = (selectedOption) => {
    setSelectedMessageType(selectedOption?.value || "");
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSelectStudents = (students) => {
    setSelectedStudents(students);
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);

    if (checked) {
      // Copy form data to table data for all students
      const updatedTableData = {};
      selectedStudents.forEach((student) => {
        const studentId = student.studentBasicDetails.id;
        updatedTableData[studentId] = {
          initiatedBy: formState.initiatedBy,
          initiationRemarks: formState.initiationRemarks,
          message: formState.message,
        };
      });
      setTableData(updatedTableData);
    } else {
      const clearedTableData = {};
      selectedStudents.forEach((student) => {
        const studentId = student.studentBasicDetails.id;
        clearedTableData[studentId] = {
          initiatedBy: "",
          initiationRemarks: "",
          message: "",
        };
      });
      setTableData(clearedTableData);
    }
  };
  const handleTableDataChange = (e, studentId) => {
    const { name, value } = e.target;

    setTableData((prevTableData) => ({
      ...prevTableData,
      [studentId]: {
        ...prevTableData[studentId],
        [name]: value,
      },
    }));
  };

  const handleSendMessage = async () => {
    if (!selectedMessageType || isNaN(selectedMessageType)) {
      alert("Please select a valid 'Message Type'.");
      return;
    }
    for (let student of selectedStudents) {
      const { studentBasicDetails: details } = student;
      const studentId = details.id;
      const studentName =
        `${details.first_name || ""} ${details.middle_name || ""} ${details.last_name || ""}`
          .replace(/\s+/g, " ")
          .trim() ||
        details.student_name ||
        details.name ||
        `ID ${studentId}`;

      const studentFormData = tableData[studentId] || {};
      const effectiveInitiatedBy =
        studentFormData.initiatedBy || formState.initiatedBy || "";

      if (!effectiveInitiatedBy) {
        alert(`Please select 'Initiated By' for student ${studentName}.`);
        return;
      }

    }
    for (let student of selectedStudents) {
      const { studentBasicDetails: details } = student;
      const studentId = details.id;
      const studentName =
        `${details.first_name || ""} ${details.middle_name || ""} ${details.last_name || ""}`
          .replace(/\s+/g, " ")
          .trim() ||
        details.student_name ||
        details.name ||
        `ID ${studentId}`;

      const studentFormData = tableData[studentId] || {};
      const effectiveMessage =
        studentFormData.message || formState.message || "";

      if (effectiveMessage.trim() === "") {
        alert(`Please enter a 'Message' for student ${studentName}.`);
        return;
      }
    }
    if (!selectedStudents || selectedStudents.length === 0) {
      alert("Please select at least one student.");
      return;
    }

    if (!formState.messageTime || formState.messageTime.trim() === "") {
      alert("Please select a valid 'Message Time'.");
      return;
    }
    const smsToMapping = { Father: "F", Mother: "M", Both: "B" };
    const smsToValue = smsToMapping[formState.smsTo] || "";
    const messageData = selectedStudents.map((student) => {
      const { studentBasicDetails: details } = student;
      const studentId = details.id;
      const studentFormData = tableData[studentId] || {};
      return {
        studentId,
        initiatedBy: studentFormData.initiatedBy || formState.initiatedBy || "",
        initiationRemarks:
          studentFormData.initiationRemarks ||
          formState.initiationRemarks ||
          "",
        message: studentFormData.message || formState.message || "",
      };
    });
    // Prepare the payload
    const payload = {
      loginId: sessionStorage.getItem("userId"),
      message_type: selectedMessageType,
      message_date: formState.messageDate,
      message_time: formState.messageTime,
      sendmessage: formState.smsTo || "",
      academicyearId: localStorage.getItem("academicSessionId"),
      studentId: messageData.map((item) => item.studentId),
      message: messageData.map((item) => item.message),
      initiatedBy: messageData.map((item) => item.initiatedBy),
      initiated_remarks: messageData.map((item) => item.initiationRemarks),
    };

    try {
      // Send the payload
      const response = await fetch(
        `${ApiUrl.apiurl}MessageSEND/StudentMessageCreate/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (data.message && data.message === "message send sucessfully!!") {
        alert(data.message);
        handleClear();
      } else {
        alert("Failed to send messages. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while sending messages.");
    }
  };

  useEffect(() => {
    const fetchFullStudentData = async () => {
      try {
        const academicSessionId = localStorage.getItem("academicSessionId");
        if (!academicSessionId) {
          console.error("No academic session ID found in local storage");
          return;
        }
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
        );
        if (!response.ok) {
          throw new Error("Error fetching student data");
        }
        const data = await response.json();
        if (data.data) {
          setFullStudentData(data.data);
        } else {
          console.warn("No data found for the given academic session ID");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchFullStudentData();
  }, []);

  // const handleAddStudents = () => {
  //   const filteredStudents = fullStudentData.filter((student) => {
  //     const { studentBasicDetails: details } = student;
  //     const schoolAdmissionNo = String(details.school_admission_no || "");
  //     const barcode = String(details.barcode || "");
  //     const admissionNoMatch = schoolAdmissionNo.includes(
  //       filterState.schoolAdmissionNo
  //     );
  //     const barcodeMatch = barcode.includes(filterState.barcode);
  //     return admissionNoMatch && barcodeMatch;
  //   });
  //   setSelectedStudents(filteredStudents);
  // };
  //New code 08042025
  const handleAddStudents = () => {
    const barcode = filterState.barcode?.trim();

    if (!barcode) {
      alert("Barcode is mandatory");
      return;
    }

    const filteredStudents = fullStudentData.filter((student) => {
      const { studentBasicDetails: details } = student;
      const studentBarcode = String(details.barcode || "");
      const barcodeMatch = studentBarcode.includes(barcode);
      return barcodeMatch;
    });

    setSelectedStudents(filteredStudents);
  };

  const handleRemoveRow = (studentId) => {
    // Remove the student from the selectedStudents
    const updatedStudents = selectedStudents.filter(
      (student) => student.studentBasicDetails.id !== studentId
    );
    setSelectedStudents(updatedStudents);
    const updatedTableData = { ...tableData };
    delete updatedTableData[studentId];
    setTableData(updatedTableData);
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT MESSAGE
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSendMessage}
                  >
                    Send Message
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/student-message")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1  mt-2">
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="message-type" className="form-label">
                          Message Type
                        </label>
                        <Select
                          inputId="message-type"
                          className="detail"
                          classNamePrefix="detail"
                          options={messageTypeOptions}
                          onChange={handleSelectChange}
                          placeholder="Select message type"
                          value={
                            messageTypeOptions.find(
                              (option) => option.value === selectedMessageType
                            ) || null
                          }
                        />
                      </div>

                      <div className="col-12 col-md-3 mt-4 ">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm mb-3"
                          disabled={isDisabled}
                          onClick={handleOpenModal}
                        >
                          Add Student(s)
                        </button>
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <div className="mb-3">
                          <label htmlFor="messageDate" className="form-label">
                            Message Date
                          </label>
                          <input
                            type="date"
                            className="form-control detail"
                            id="messageDate"
                            name="messageDate"
                            value={formState.messageDate}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <div className="mb-3">
                          <label className="form-label">Send SMS to</label>
                          <div className="d-flex">
                            <div className="form-check me-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="smsTo"
                                id="smsToFather"
                                value="F"
                                checked={formState.smsTo === "F"}
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="smsToFather"
                              >
                                Father
                              </label>
                            </div>
                            <div className="form-check me-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="smsTo"
                                id="smsToMother"
                                value="M"
                                checked={formState.smsTo === "M"}
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="smsToMother"
                              >
                                Mother
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="smsTo"
                                id="smsToBoth"
                                value="B"
                                checked={formState.smsTo === "B"}
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="smsToBoth"
                              >
                                Both
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <div className="mb-3">
                          <label htmlFor="messageTime" className="form-label">
                            Message Time
                          </label>
                          <input
                            type="time"
                            className="form-control detail"
                            id="messageTime"
                            name="messageTime"
                            value={formState.messageTime}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <div className="mb-3">
                          <label htmlFor="barcode" className="form-label">
                            Barcode
                          </label>
                          <input
                            type="text"
                            className="form-control detail"
                            id="barcode"
                            name="barcode"
                            value={filterState.barcode}
                            onChange={(e) =>
                              setFilterState({
                                ...filterState,
                                barcode: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mt-4">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm mb-3"
                          onClick={handleAddStudents}
                        >
                          Add Students
                        </button>
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="from-class" className="form-label">
                          Initiated By
                        </label>
                        <Select
                          inputId="from-class"
                          className="detail"
                          classNamePrefix="detail"
                          name="initiatedBy"
                          options={initiatedByOptions}
                          placeholder="Select initiated by"
                          value={
                            initiatedByOptions.find(
                              (option) => option.value === formState.initiatedBy
                            ) || null
                          }
                          onChange={handleInitiatedByChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <div className="mb-3">
                          <label
                            htmlFor="initiationRemarks"
                            className="form-label"
                          >
                            Initiation Remarks
                          </label>
                          <input
                            type="text"
                            className="form-control detail"
                            id="initiationRemarks"
                            name="initiationRemarks"
                            value={formState.initiationRemarks}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="message" className="form-label">
                          Message
                        </label>
                        <textarea
                          className="form-control detail"
                          id="message"
                          rows="3"
                          name="message"
                          value={formState.message}
                          onChange={handleChange}
                          style={{ resize: "both", overflow: "auto" }}
                        ></textarea>
                        <div className="form-check mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="copyMessageDetails"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="copyMessageDetails"
                          >
                            Copy Message Details
                          </label>
                        </div>
                      </div>

                      <Modal
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudents}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Roll No</th>
                        <th
                          style={{ paddingLeft: "50px", paddingRight: "50px" }}
                        >
                          Student Name
                        </th>
                        <th>Barcode</th>
                        <th
                          style={{ paddingLeft: "50px", paddingRight: "50px" }}
                        >
                          Father Name
                        </th>
                        <th
                          style={{ paddingLeft: "50px", paddingRight: "50px" }}
                        >
                          Mother Name
                        </th>
                        <th
                          style={{ paddingLeft: "40px", paddingRight: "40px" }}
                        >
                          Initiated By
                        </th>
                        <th
                          style={{ paddingLeft: "40px", paddingRight: "40px" }}
                        >
                          Initiation Remarks
                        </th>
                        <th
                          style={{ paddingLeft: "60px", paddingRight: "60px" }}
                        >
                          Message
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedStudents.length > 0 ? (
                        selectedStudents.map((student, index) => {
                          const { studentBasicDetails: details } = student;
                          const studentId = details.id;
                          const studentData = tableData[studentId] || {};

                          return (
                            <tr key={studentId}>
                              <td>{index + 1}</td>
                              <td>{details.classname}</td>
                              <td>{details.sectionname}</td>
                              <td>{details.rollno}</td>
                              <td>{`${details.first_name} ${details.middle_name || ""
                                } ${details.last_name}`}</td>
                              <td>{details.barcode}</td>
                              <td>{details.father_name}</td>
                              <td>{details.mother_name}</td>
                              <td>
                                <select
                                  className="form-select"
                                  value={
                                    tableData[studentId]?.initiatedBy || ""
                                  }
                                  name="initiatedBy"
                                  onChange={(e) =>
                                    handleTableDataChange(e, studentId)
                                  }
                                >
                                  <option value="">Select initiated by</option>
                                  {initiatedByList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.InitiatedBy_desc}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control detail"
                                  name="initiationRemarks"
                                  value={
                                    tableData[studentId]?.initiationRemarks ||
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleTableDataChange(e, studentId)
                                  }
                                />
                              </td>
                              {/* <td>
                                <textarea
                                  className="form-control detail"
                                  rows="2"
                                  name="message"
                                  value={tableData[studentId]?.message || ""}
                                  onChange={(e) =>
                                    handleTableDataChange(e, studentId)
                                  }
                                  style={{ resize: "both", overflow: "auto" }}
                                ></textarea>
                              </td> */}
                              <td>
                                <textarea
                                  className="form-control detail"
                                  rows="2"
                                  name="message"
                                  value={tableData[studentId]?.message || ""}
                                  onChange={(e) =>
                                    handleTableDataChange(e, studentId)
                                  }
                                  style={{
                                    resize: "none",
                                    overflow: "auto",
                                    maxHeight: "100px",
                                    width: "100%",
                                    boxSizing: "border-box",
                                  }}
                                ></textarea>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={() => handleRemoveRow(studentId)}
                                >
                                  Remove
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No record found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectedStudentTable;
